import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal";
import { FIRM } from "../data/content";

const EXPERIENCE = [
  { org: "Wipro · Blackstone JV", role: "Head of Legal & Compliance, APAC", note: "Built the function 3→16 across 6 jurisdictions; USD 3M+ saved; 300+ contracts / year." },
  { org: "Oliver Wyman", role: "Senior Counsel, APAC", note: "Cross-border commercial & regulatory advisory across Asia-Pacific." },
  { org: "KPMG Singapore", role: "Senior Legal Counsel", note: "500+ contracts/yr across tax, advisory, digital & SaaS; data privacy (PDPA/GDPR)." },
  { org: "Luthra & Luthra", role: "Associate, Competition Law", note: "Competition Commission of India and Supreme Court matters — including a cartelisation and bid-rigging defence." },
  { org: "Suri and Company", role: "Associate, Corporate Law", note: "M&A, JVs, FDI structuring; part of the team advising the Organising Committee of the Commonwealth Games 2010." },
];

const EXPERTISE = [
  "Commercial Contracting", "Technology & SaaS", "M&A & JV Structuring",
  "APAC Governance", "Legal Ops Design", "Data Privacy (GDPR/DPDP)",
];

export default function Founder() {
  return (
    <section id="firm" className="relative z-10 py-28 md:py-40 bg-[#0B132B]/40" data-testid="firm">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <Reveal className="lg:col-span-5" y={60}>
          <div className="relative">
            <div className="absolute -inset-3 border border-[#D95A41]/40 rounded-2xl translate-x-4 translate-y-4" />
            <div
              className="relative overflow-hidden rounded-2xl bg-[#050A14] border border-white/10"
              style={{ clipPath: "polygon(0 0, 100% 0, 100% 92%, 92% 100%, 0 100%)" }}
              data-testid="founder-portrait"
            >
              <img
                src="/team/shray-kamboj.jpg?v=3"
                alt="Shray Kamboj, Managing Partner"
                className="w-full h-[480px] object-contain object-center bg-[#0B132B]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050A14]/70 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6">
                <p className="text-lg font-700 text-[#F2EFE9]">Shray Kamboj</p>
                <p className="text-sm text-[#F2EFE9]/70">Managing Partner</p>
              </div>
            </div>
          </div>

          <div className="mt-8 flex flex-wrap gap-2">
            {EXPERTISE.map((e) => (
              <span key={e} className="px-3 py-1.5 rounded-full border border-white/15 text-xs font-500 text-[#94A3B8]">
                {e}
              </span>
            ))}
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          <Reveal>
            <p className="text-sm font-500 tracking-[0.3em] uppercase text-[#D95A41] mb-6">Current Leadership</p>
            <h2 className="text-4xl md:text-5xl font-900 tracking-tightest leading-[1.02] text-[#F2EFE9]">
              Governance-led foundation.<br />APAC in-house leadership.
            </h2>
          </Reveal>

          <Reveal delay={0.1}>
            <p className="mt-8 text-lg text-[#94A3B8] leading-relaxed">
              KLC is led by <span className="text-[#F2EFE9] font-700">Shray Kamboj, LL.M.</span> (National University of
              Singapore) — an internationally trained lawyer with over fourteen years across India and the Asia-Pacific.
              His practice pairs the commercial fluency of an in-house function with the responsiveness of a boutique firm.
            </p>
          </Reveal>

          <div className="mt-10 space-y-px">
            {EXPERIENCE.map((x, i) => (
              <Reveal key={x.org} delay={0.05 * i}>
                <div className="grid grid-cols-1 md:grid-cols-12 gap-2 md:gap-6 py-6 border-t border-white/10">
                  <div className="md:col-span-4 font-700 text-[#F2EFE9]">{x.org}</div>
                  <div className="md:col-span-3 text-sm text-[#D95A41] font-500">{x.role}</div>
                  <div className="md:col-span-5 text-sm text-[#94A3B8] leading-relaxed">{x.note}</div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.15}>
            <a
              href={FIRM.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="founder-linkedin"
              className="mt-8 inline-flex items-center gap-2 text-[#F2EFE9] font-700 hover:text-[#D95A41] transition-colors"
            >
              View full profile on LinkedIn <ArrowUpRight size={18} />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
